import { environment } from './../../environments/environment';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { LobbyService } from './../_services/lobby.service';
import { Store } from '@ngrx/store';
import { AppState}  from '../../app/app.state';
@Component({
  selector: 'app-game-selector',
  templateUrl: './game-selector.component.html',
  styleUrls: ['./game-selector.component.scss']
})
export class GameSelectorComponent implements OnInit, OnDestroy {

  @Input('page') page = 'lobby';
  darkMode=false;
  darkMode_ext='';
  curGame = 'all'
  curGameAbbr = 'all';
  games = [];
  sub_currentGame: Subscription;
  bucketURL = `${environment.assetURL}` + '/assets/default/images/';
  loading = false;

  constructor(private _lobbyService: LobbyService,private store: Store<AppState>) {
    this.sub_currentGame = this._lobbyService.cgObservable.subscribe(state => {
      if (state.game != null && state.abbr != null) {
        this.curGame = state.game;
        this.curGameAbbr = state.abbr;
      }
    });
     this.store.select('DarkModeReducer').subscribe(state => {
      if (state.length > 0) {
        this.darkMode = state[0].isDarkMode;
        this.darkMode_ext = this.darkMode?'-dark':'';
      }
    });
  }

  setGame(game, abbr, season) {
    this.loading = true;
    this._lobbyService.setCurrentGame({
      game,
      abbr,
      season
    });
    setTimeout(()=>{
      this.curGame = game;
      this.curGameAbbr = abbr;
      this.loading = false;
    },2000);
  }

  getGames() {
    this._lobbyService.getGames(this.page).subscribe(res => {
      if (res.status == 'success') {
        if (this.page == 'lobby' || this.page == 'myteams') {
          this.games[0] = {
            name: 'All',
            status: 'Y',
            id: 'all',
            active_Season_id: '29'
          };
        }
        res.entities.forEach(game => {
          this.games.push(game);
        });
        this.setGame(this.games[0].id, this.games[0].name, this.games[0].active_Season_id);
      }
    });
  }

  ngOnInit() {
    if (this.page != 'lobby') {
      this.curGame = '2';
      this.curGameAbbr = 'nfl';
    }
    this.getGames();
  }

  ngOnDestroy() {
    if (this.sub_currentGame) { this.sub_currentGame.unsubscribe(); }
  }

}
